import type { LayerSpecification } from 'maplibre-gl';

const primary = '#369639';

export function generate_area_layers(): Array<LayerSpecification> {
    return [
        {
            id: 'areas_fill',
            type: 'fill',
            source: 'areas',
            paint: {
                'fill-color': primary,
                'fill-opacity': 0.1,
                'fill-outline-color': primary,
            },
        },
        {
            id: 'areas_outlines',
            type: 'line',
            source: 'areas',
            paint: {
                'line-color': primary,
                'line-width': 3,
            },
        },
        {
            id: 'map_item_areas_fill',
            type: 'fill',
            source: 'mapItemAreas',
            paint: {
                'fill-color': primary,
                'fill-opacity': 0.1,
                'fill-outline-color': primary,
            },
        },
        {
            id: 'map_item_areas_outlines',
            type: 'line',
            source: 'mapItemAreas',
            paint: {
                'line-color': primary,
                'line-width': 3,
            },
        },
    ];
}
